import { render, staticRenderFns } from "./AsideMenuList.vue?vue&type=template&id=19739771&"
import script from "./AsideMenuList.vue?vue&type=script&lang=ts&"
export * from "./AsideMenuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports